var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import Config from "../config/config.js";
import { Event } from "../models/enums.js";
import { bulma } from "../scss/bulma.styles.js";
import { ctc } from "../scss/ctc.styles.js";
import { fontawesome } from "../scss/fontawesome.styles.js";
import { DataStore } from "../services/datastore.service.js";
import { EventBus } from "../services/eventbus.service.js";
import { System } from "../services/system.service.js";
import Utils from "../utils/utils.js";
var ModalType;
(function (ModalType) {
    ModalType["ACCEPTREJECT"] = "modalacceptreject";
    ModalType["CLIP"] = "modalclip";
})(ModalType || (ModalType = {}));
let AppCard = class AppCard extends LitElement {
    constructor() {
        super();
        this.loading = false;
        this.accept = false;
        this.buttonDisabled = false;
        this.rotatedCard = false;
        this.helprecipient = false;
        this.height = 220;
        this.descriptionlength = 0;
        this.emails = [];
        this.edit = false;
        this.owner = false;
        this.displayfrom = false;
        this.displayto = false;
        this.displaylink = false;
        this.displayclip = false;
        this.datastore = DataStore.getInstance();
        this.eventbus = EventBus.getInstance();
        this.system = System.getInstance();
    }
    firstUpdated() {
        if (this.edit) {
            (this.shadowRoot?.getElementById("select-size")).value = this.card.size.toString();
            (this.shadowRoot?.getElementById("select-timeouttype")).value = this.card.timeouttype.toString();
            const array = this.card.recipient.split("<");
            (this.shadowRoot?.getElementById("name")).value = array[0].trim();
            if (array.length === 2) {
                (this.shadowRoot?.getElementById("email")).value = array[1].slice(0, -1).trim();
            }
            this.descriptionlength = (this.shadowRoot?.getElementById("description")).value.trim().length;
            this.datastore
                .fetchExistingEmails()
                .then((response) => {
                this.emails = response;
                this.requestUpdate();
            })
                .catch((error) => {
                this.eventbus.dispatchError(error);
            });
        }
        const cardEl = this.shadowRoot?.getElementById("card");
        if (cardEl) {
            this.height = cardEl.clientHeight;
            this.cardObserver = new ResizeObserver((entries) => {
                this.height = entries[0].contentRect.height;
            });
            this.cardObserver.observe(cardEl);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.cardObserver?.disconnect();
    }
    checkValues() {
        const email = (this.shadowRoot?.getElementById("email")).value.trim();
        if (!email) {
            this.requestUpdate();
        }
    }
    updateValues(refresh) {
        const name = (this.shadowRoot?.getElementById("name")).value.trim();
        const email = (this.shadowRoot?.getElementById("email")).value.trim();
        if (email.length > 0) {
            this.card.recipient = name + " <" + email + ">";
        }
        else {
            this.card.recipient = name;
        }
        this.card.title = (this.shadowRoot?.getElementById("title")).value.trim();
        this.card.description = (this.shadowRoot?.getElementById("description")).value.trim();
        this.card.size = Number((this.shadowRoot?.getElementById("select-size")).value);
        this.card.timeout = Number((this.shadowRoot?.getElementById("timeout")).value);
        this.card.timeouttype = (this.shadowRoot?.getElementById("select-timeouttype")).value;
        if (refresh) {
            this.requestUpdate();
        }
    }
    getCardLink() {
        return location.protocol + "//" + location.host + "/link/" + this.card.id + "/" + this.card.gid;
    }
    async copyLink() {
        const r = await this.system.copyToClipboard(this.getCardLink());
        if (r === true) {
            this.eventbus.dispatchEvent(Event.Toast, {
                text: "Link copied to clipboard",
                classes: "fas fa-copy",
                type: "is-info",
            });
        }
        else {
            this.eventbus.dispatchEvent(Event.Toast, {
                text: "Failed copying to clipboard",
                classes: "fas fa-exclamation",
                type: "is-danger",
            });
        }
    }
    shareAvailable() {
        return this.system.shareAvailable();
    }
    shareLink() {
        this.system.share("Clip The Card", "Link to card", this.getCardLink());
    }
    openModal(modal) {
        (this.shadowRoot?.getElementById("message")).value = "";
        (this.shadowRoot?.getElementById(modal)).classList.add("is-active");
    }
    closeModal(modal) {
        (this.shadowRoot?.getElementById(modal)).classList.remove("is-active");
    }
    acceptTheCard(accept) {
        this.accept = accept;
        this.loading = true;
        this.datastore
            .acceptOrRejectTheCard(this.card.id, this.card.gid, accept)
            .then((_) => {
            this.loading = false;
            this.buttonDisabled = true;
            this.shadowRoot?.querySelectorAll(".morphing-icons").forEach((div) => {
                div.classList.toggle("morphed");
            });
            setTimeout(() => {
                this.buttonDisabled = false;
                this.closeModal(ModalType.ACCEPTREJECT);
                this.shadowRoot?.querySelectorAll(".morphing-icons").forEach((div) => {
                    div.classList.toggle("morphed");
                });
                if (accept) {
                    this.card.accepted = Utils.utcDateString();
                }
                else {
                    this.eventbus.dispatchEvent(Event.Refresh);
                }
            }, 1000);
        })
            .catch((error) => {
            this.eventbus.dispatchError(error);
        })
            .finally(() => {
            this.loading = false;
            this.requestUpdate();
        });
    }
    closeAcceptModal() {
        this.closeModal(ModalType.ACCEPTREJECT);
    }
    clipTheCard() {
        this.loading = true;
        const message = (this.shadowRoot?.getElementById("message")).value.trim();
        this.datastore
            .clipTheCard(this.card.id, this.card.gid, message)
            .then((response) => {
            this.loading = false;
            this.buttonDisabled = true;
            this.shadowRoot?.querySelectorAll(".morphing-icons").forEach((div) => {
                div.classList.toggle("morphed");
            });
            this.card?.clips.push(response);
            this.eventbus.dispatchEvent(Event.RequestUpdate);
            setTimeout(() => {
                this.buttonDisabled = false;
                this.closeModal(ModalType.CLIP);
                this.shadowRoot?.querySelectorAll(".morphing-icons").forEach((div) => {
                    div.classList.toggle("morphed");
                });
            }, 1000);
        })
            .catch((error) => {
            this.eventbus.dispatchError(error);
        })
            .finally(() => {
            this.loading = false;
            this.requestUpdate();
        });
    }
    showHelpRecipient() {
        this.helprecipient = true;
    }
    hideHelpRecipient() {
        this.helprecipient = false;
    }
    rotateCard() {
        if (this.card?.status === "active" || this.card?.status === "archived") {
            if (this.shadowRoot?.getElementById("fci")?.classList.contains("flip-card-rotate")) {
                this.shadowRoot.getElementById("fci")?.classList.remove("flip-card-rotate");
                this.rotatedCard = false;
            }
            else {
                this.shadowRoot?.getElementById("fci")?.classList.add("flip-card-rotate");
                this.rotatedCard = true;
            }
        }
    }
    switchDelivered(i) {
        this.datastore
            .clipTheCardDelivered(this.card.id, this.card.gid, i)
            .then((response) => {
            this.card.clips[i].delivered = response.delivered;
            this.requestUpdate();
        })
            .catch((error) => {
            this.eventbus.dispatchError(error);
        });
    }
    switchReceived(i) {
        this.datastore
            .clipTheCardReceived(this.card.id, this.card.gid, i)
            .then((response) => {
            this.card.clips[i].received = response.received;
            this.requestUpdate();
        })
            .catch((error) => {
            this.eventbus.dispatchError(error);
        });
    }
    render() {
        if (this.card === undefined) {
            return html `card is undefined`;
        }
        const clipLines = [];
        for (let i = 0; i < this.card.size; i++) {
            const created = this.card.clips[i] ? this.card.clips[i].created : "";
            const delivered = this.card.clips[i] ? this.card.clips[i].delivered : "";
            const received = this.card.clips[i] ? this.card.clips[i].received : "";
            const complete = delivered !== "" && delivered !== undefined && received !== "" && received !== undefined;
            const message = this.card.clips[i] ? this.card.clips[i].message : "";
            clipLines.push(this.htmlCliplines(created, i, complete, delivered, received, message));
        }
        clipLines.reverse();
        return this.edit ? this.htmlEditCard(clipLines) : this.htmlViewCard(clipLines);
    }
    htmlViewCard(clipLines) {
        return html `
          <div class="flip-card" style="height: ${this.height + "px"}">
            <div id="fci" class="flip-card-inner">
              <div class="flip-card-front">
                <div id="card" class="ctc-card">
                  <div class="${this.owner ? "ctc-header-owner" : "ctc-header"}">
                    ${this.displayfrom
            ? html `
                          <div class="is-size-7">
                            <span class="icon">
                              <i class="fas fa-paper-plane"></i>
                            </span>
                            ${this.card.creatorname} &lt;${this.card.creatoremail}&gt;
                          </div>
                        `
            : ""}
                    ${this.displayto
            ? html `
                          <div class="is-size-7">
                            <span class="icon">
                              <i class="fas fa-inbox"></i>
                            </span>
                            ${this.card.recipient}
                          </div>
                        `
            : ""}
                    <div class="mt-2 mb-4">${this.card.title}</div>
                    ${this.displayclip && this.datastore.user?.email !== this.card.creatoremail
            ? html `
                          ${this.card.accepted === undefined &&
                this.card.rejected === undefined &&
                this.card.clips.length === 0 &&
                this.card.recipientid !== undefined
                ? html `
                                <button
                                  class="button is-primary"
                                  @click="${(_) => this.openModal(ModalType.ACCEPTREJECT)}"
                                  ?disabled=${this.card.clips.length === this.card.size}
                                >
                                  <span class="icon">
                                    <i class="fas fa-thumbs-up"></i>
                                  </span>
                                  <span>/</span>
                                  <span class="icon">
                                    <i class="fas fa-thumbs-down"></i>
                                  </span>
                                </button>
                              `
                : html `
                                <button
                                  class="button is-primary"
                                  @click="${(_) => this.openModal(ModalType.CLIP)}"
                                  ?disabled=${this.card.clips.length === this.card.size}
                                >
                                  <span class="icon">
                                    <i class="fas fa-hand-scissors"></i>
                                  </span>
                                  <span>Clip</span>
                                </button>
                              `}
                        `
            : ""}
                  </div>
                  ${this.card.status === "draft"
            ? html `
                        <div class="watermark">
                          <div class="watermark__inner">
                            <div class="watermark__body">
                              <i class="fas fa-edit"></i>
                            </div>
                          </div>
                          <div class="ctc-description has-text-black">${this.card.description}</div>
                          ${clipLines}
                        </div>
                      `
            : html ` <div class="ctc-description has-text-black">${this.card.description}</div>
                        ${clipLines}`}
                </div>
              </div>
              <div class="flip-card-back">
                <div class="ctc-card" style="height: ${this.height + "px"}">
                  <div class="ctc-back">
                    <span class="icon is-clickable flip-card-rotator-back has-text-grey-lighter" @click="${() => this.rotateCard()}">
                      <i class="fas fa-rotate"></i>
                    </span>
                    <div class="columns" style="max-height: ${this.height - 10 + "px"}; overflow-y: auto">
                      <div class="column content has-text-light is-size-7">
                        ${this.displaylink ? html `
                        <div class="has-text-centered">
                        <figure class="image is-128x128 is-inline-block">
                            <img
                            src="${Config.backendhost}/api/anonymous/qr?url=${encodeURIComponent(Config.frontendhost + "/link/" + this.card.id + "/" + this.card.gid)}"
                            alt="Link to card"
                            />
                        </figure>
                        </div>
                        <div class="has-text-centered">
                        <span class="tag is-clickable" @click="${(_) => this.copyLink()}">
                            <span class="icon is-small">
                            <i class="fas fa-copy"></i>
                            </span>
                            <small>Copy link</small>
                        </span>
                        ${this.shareAvailable() ? html `
                        <span class="tag is-clickable" @click="${(_) => this.shareLink()}">
                            <span class="icon is-small">
                            <i class="fas fa-share-alt"></i>
                            </span>
                            <small>Share link</small>
                        </span>
                        ` : ''}
                        </div>
                        ` : ""}
                        <div class="mt-2" style="width:230px;margin:auto;">
                          <small>
                            <span class="icon">
                              <i class="fas fa-hashtag"></i>
                            </span>
                            <span>${this.card.gid}</span>
                            <br />
                            <span class="icon">
                              <i class="fas fa-plus"></i>
                            </span>
                            <span>${this.card.created}</span>
                            <br />
                            <span class="icon">
                              <i class="fas fa-hourglass"></i>
                            </span>
                            <span>${this.card.timeout === 0 ? "n/a" : this.card.timeout + " " + this.card.timeouttype}</span>
                            <br />
                            ${this.card.activated ? html `
                                <span class="icon">
                                    <i class="fas fa-paper-plane"></i>
                                </span>
                                <span>${this.card.activated}</span>
                                <br />                            ` : ""}
                            ${this.card.accepted ? html `
                                  <span class="icon">
                                    <i class="fas fa-thumbs-up"></i>
                                  </span>
                                  <span>${this.card.accepted}</span>
                                  <br />
                            ` : ""}
                            ${this.card.rejected ? html `
                                  <span class="icon">
                                    <i class="fas fa-thumbs-down"></i>
                                  </span>
                                  <span>${this.card.rejected}</span>
                                  <br />
                            ` : ""}
                            ${this.card.status === "archived" ? html `
                                <span class="icon">
                                    <i class="fas fa-archive"></i>
                                </span>
                                <span>${this.card.archived}</span>
                                <br />
                           ` : ""}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="modalacceptreject" class="modal">
            <div class="modal-background"></div>
            <div class="modal-card">
              <header class="modal-card-head has-background-primary">
                <p class="modal-card-title has-text-white morphing-icons">
                  <i class="fas fa-question"></i>
                  <i class="fas fa-${this.accept ? "thumbs-up" : "thumbs-down"}"></i>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'${this.card.title}'
                </p>
              </header>
              <section class="modal-card-body has-text-black">
                Will you accept this card from ${this.card.creatorname + " <" + this.card.creatoremail + ">"}. <br /><br />
                If you reject the card it will be archived directly.
              </section>
              <footer class="modal-card-foot">
                <div class="container is-fluid has-text-centered">
                  <button class="button is-success is-pulled-left" ?disabled=${this.buttonDisabled} @click="${(_) => this.acceptTheCard(true)}">
                    <span class="icon">
                      <i class="fas ${this.loading ? "fa-circle-notch fa-spin" : "fa-thumbs-up"}"></i>
                    </span>
                    <span>Accept</span>
                  </button>
                  <button class="button is-danger is-pulled-right" ?disabled=${this.buttonDisabled} @click="${(_) => this.acceptTheCard(false)}">
                    <span class="icon">
                      <i class="fas ${this.loading ? "fa-circle-notch fa-spin" : "fa-thumbs-down"}"></i>
                    </span>
                    <span>Reject</span>
                  </button>
                  <div class="is-clearfix">
                    <button class="button is-rounded mt-2" @click="${(_) => this.closeAcceptModal()}">
                        <span class="icon">
                            <i class="far fa-times"></i>
                        </span>
                    </button>
                  </div>
                </div>
              </footer>
            </div>
          </div>

          <div id="modalclip" class="modal">
            <div class="modal-background"></div>
            <div class="modal-card">
              <header class="modal-card-head has-background-primary">
                <p class="modal-card-title has-text-white morphing-icons">
                  <i class="fas fa-hand-scissors"></i>
                  <i class="fas fa-check"></i>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'${this.card.title}' ?
                </p>
              </header>
              <section class="modal-card-body has-text-black">
                <div class="container">
                    <div class="notification mb-0">
                        We will notify ${this.card.creatorname + " <" + this.card.creatoremail + ">"} if you clip the card.
                    </div>
                    <div class="field">
                        <p class="control has-icons-left">
                          <input
                            id="message"
                            class="input"
                            type="text"
                            placeholder="Message" />
                            <span class="icon is-left">
                                <i class="fas fa-comment-dots"></i>
                            </span>
                        </p>
                  </div>
                </div>
              </section>
              <footer class="modal-card-foot">
                <div class="container is-fluid has-text-centered">
                  <button class="button is-success is-pulled-left" ?disabled=${this.buttonDisabled} @click="${this.clipTheCard}">
                    <span class="icon">
                      <i class="fas ${this.loading ? "fa-circle-notch fa-spin" : "fa-hand-scissors"}"></i>
                    </span>
                    <span>Clip</span>
                  </button>
                  <button class="button is-warning is-pulled-right" @click="${(_) => this.closeModal(ModalType.CLIP)}">
                    <span class="icon">
                      <i class="fas fa-times"></i>
                    </span>
                    <span>Close</span>
                  </button>
                </div>
              </footer>
            </div>
          </div>
        `;
    }
    htmlExistingEmails() {
        const element = this.shadowRoot?.getElementById("email");
        if (!element) {
            return "";
        }
        let tags = [];
        for (let i = 0; i < this.emails.length; i++) {
            tags.push(html `
                <span class="tag is-clickable" @click="${() => { element.value = this.emails[i]; this.requestUpdate(); }}">
                    <span class="icon is-small">
                        <i class="fas fa-at"></i>
                    </span>
                    <small>${this.emails[i]}</small>
                </span>
            `);
        }
        return tags.length > 0 && element.value.length === 0 ? html `<div class="has-text-left">
                        <div style="height:50px; overflow-x: auto;white-space: nowrap;">
                            ${tags}
                        </div>
                    </div>`
            : "";
    }
    htmlEditCard(clipLines) {
        return html `
          <div class="ctc-card">
            <div class="ctc-header-owner">
              <div class="columns is-mobile">
                <div class="column is-11">
                  <div class="field">
                    <p class="control has-icons-left">
                      <input
                        id="name"
                        class="input"
                        type="text"
                        placeholder="John Doe"
                        @change=${this.updateValues}
                      />
                      <span class="icon is-left">
                        <i class="fas fa-user"></i>
                      </span>
                    </p>
                  </div>
                  <div class="field">
                    <p class="control has-icons-left">
                      <input
                        id="email"
                        class="input"
                        type="email"
                        placeholder="jd@example.com"
                        @change=${this.updateValues}
                        @keyup=${this.checkValues}
                      />
                      <span class="icon is-left">
                        <i class="fas fa-at"></i>
                      </span>
                    </p>
                  </div>
                  ${this.htmlExistingEmails()}
                </div>
                <div class="column">
                ${!this.helprecipient ? html `
                  <span class="icon is-small is-right is-clickable" @click="${this.showHelpRecipient}">
                    <i class="fas fa-question"></i>
                  </span>
                ` : ""}
                </div>
              </div>
              ${this.helprecipient
            ? html `
                    <div class="notification is-info is-size-7 has-text-left">
                      <button class="delete" @click="${this.hideHelpRecipient}"></button>
                      Recipient can be specified by name, email or both.<br />
                      <br />
                      <i class="fas fa-user"></i> Name: the name of the person.<br />
                      <i class="fas fa-at"></i> Email: the email of the person.<br />
                      <br />
                      If the email is registered with ClipTheCard, the card will only be accessible to the user and login is required.<br />
                      If the email is not registered with ClipTheCard or not specified, the card will be available as an anonymous card via a link.
                    </div>
                  `
            : ""}
              <div class="columns is-mobile">
                <div class="column is-11">
                  <div class="field">
                    <p class="control has-icons-left has-icons-right">
                      <input id="title" class="input" type="text" placeholder="Title of card" .value="${this.card.title}" @change=${this.updateValues} />
                      <span class="icon is-left">
                        <i class="fas fa-newspaper"></i>
                      </span>
                      <span class="icon is-right">
                        <i class="fas fa-star"></i>
                      </span>
                    </p>
                  </div>
                </div>
                <div class="column"></div>
              </div>
            </div>
            <div class="ctc-description">
              <div class="field mb-0">
                <div class="control">
                  <textarea
                    id="description"
                    class="textarea is-primary"
                    placeholder="Description"
                    .value="${this.card.description}"
                    @change=${this.updateValues}
                    @keyup=${() => { this.descriptionlength = (this.shadowRoot?.getElementById("description")).value.trim().length; }}
                  ></textarea>
                </div>
              </div>
              <div class="has-text-right">
                  <span class="icon is-small">
                      <i class="fas fa-keyboard"></i>
                  </span>
                  <small>${this.descriptionlength} / 2500</small>
              </div>
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <p class="control">
                      <button class="button is-primary">
                        <span class="icon">
                          <i class="fas fa-hand-scissors"></i>
                        </span>
                        <span>Clips</span>
                      </button>
                      <span class="select is-fullwidth">
                        <select id="select-size" @change=${this.updateValues}>
                          <option>1</option>
                          <option>3</option>
                          <option>5</option>
                          <option>10</option>
                        </select>
                      </span>
                    </p>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <p class="control">
                      <button class="button is-primary">
                        <span class="icon">
                          <i class="fas fa-hourglass"></i>
                        </span>
                        <span>Timeout between clips</span>
                      </button>
                      <span class="control">
                        <input id="timeout" class="input" type="text" placeholder="0 is disabled" value=${this.card.timeout} @change=${this.updateValues} />
                      </span>
                    </p>
                  </div>

                  <div class="field">
                    <p class="control">
                      <button class="button is-primary">
                        <span class="icon">
                          <i class="fas fa-clock"></i>
                        </span>
                        <span>Timeout countdown</span>
                      </button>
                      <span class="select is-fullwidth">
                        <select id="select-timeouttype" @change=${this.updateValues}>
                          <option value="seconds">seconds</option>
                          <option value="minutes">minutes</option>
                          <option value="hours">hours</option>
                          <option value="days">days</option>
                        </select>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            ${clipLines}
          </div>
        `;
    }
    htmlCliplines(created, i, complete, delivered, received, message) {
        return html `
        <div class="ctc-line">
          <div class="ctc-${created === "" ? "uncut" : "cut"}">${i + 1}</div>
          <div class="ctc-info has-text-black">${created === "" ? "" : Utils.localDateTimeFormatted(created)}</div>
          <div class="ctc-confirmed">
            ${complete
            ? html `
                    <span class="icon has-text-primary">
                      <i class="fas fa-circle-check"></i>
                    </span>
            ` : ""}
            ${!complete && this.card.status === "active" && this.owner && created !== ""
            ? delivered === undefined || delivered === null
                ? html `
                    <span @click="${() => this.switchDelivered(i)}" class="icon is-clickable">
                      <i class="fas fa-question"></i>
                    </span>
                  `
                : html `
                    <span @click="${() => this.switchDelivered(i)}" class="icon is-clickable has-text-primary">
                      <i class="fas fa-check"></i>
                    </span>
                  `
            : ""}
            ${!complete && this.card.status === "active" && !this.owner && created !== ""
            ? received === undefined || received === null
                ? html `
                    <span @click="${() => this.switchReceived(i)}" class="icon is-clickable">
                      <i class="fas fa-question"></i>
                    </span>
                  `
                : html `
                    <span @click="${() => this.switchReceived(i)}" class="icon is-clickable has-text-primary">
                      <i class="fas fa-check"></i>
                    </span>
                  `
            : ""}
          </div>

          <div class="ctc-message has-text-black">
            ${message ? html `
            <span>
                <i class="fas fa-comment-dots"></i>
                ${message}
            </span>
                    ` : ""}
          </div>

          <div class="ctc-right">
            ${i === 0 && this.rotatedCard === false && this.card.status !== "draft"
            ? html `
                  <span class="icon is-clickable flip-card-rotator-front has-text-grey" @click="${() => this.rotateCard()}">
                    <i class="fas fa-rotate"></i>
                  </span>
            ` : ""}
          </div>
        </div>
      `;
    }
};
AppCard.styles = [bulma, ctc, fontawesome];
__decorate([
    state()
], AppCard.prototype, "loading", void 0);
__decorate([
    state()
], AppCard.prototype, "accept", void 0);
__decorate([
    state()
], AppCard.prototype, "buttonDisabled", void 0);
__decorate([
    state()
], AppCard.prototype, "rotatedCard", void 0);
__decorate([
    state()
], AppCard.prototype, "helprecipient", void 0);
__decorate([
    state()
], AppCard.prototype, "height", void 0);
__decorate([
    state()
], AppCard.prototype, "descriptionlength", void 0);
__decorate([
    state()
], AppCard.prototype, "emails", void 0);
__decorate([
    property({ type: Boolean })
], AppCard.prototype, "edit", void 0);
__decorate([
    property({ type: Boolean })
], AppCard.prototype, "owner", void 0);
__decorate([
    property({ type: Boolean })
], AppCard.prototype, "displayfrom", void 0);
__decorate([
    property({ type: Boolean })
], AppCard.prototype, "displayto", void 0);
__decorate([
    property({ type: Boolean })
], AppCard.prototype, "displaylink", void 0);
__decorate([
    property({ type: Boolean })
], AppCard.prototype, "displayclip", void 0);
__decorate([
    property({ type: Object })
], AppCard.prototype, "card", void 0);
AppCard = __decorate([
    customElement("app-card")
], AppCard);
export { AppCard };
//# sourceMappingURL=card.component.js.map